// extracted by mini-css-extract-plugin
export default {"container":"pending_container__2SgFT","pending":"pending_pending__eoq64"};